<template>
  <v-content>
    <v-container
      id="login"

      tag="section"
    >
      <v-row justify="center">
        <v-slide-y-transition appear>
          <v-col cols="12">
            <validation-observer v-slot="{ handleSubmit }">
              <form
                id="loginForm"
                @submit.prevent="handleSubmit(validateForm)"
              >
                <base-material-card
                  color="success"
                  light
                  icon="mdi-camera-account"
                  max-width="100%"
                  width="600"
                  class="px-5 py-3"
                >
                  <v-card-title
                    class="justify-center"
                  >
                    NetToWin Anmeldung
                  </v-card-title>
                  <v-row
                    align="center"
                    dense
                  >
                    <v-col
                      class="text-right body-1 grey--text"
                      cols="2"
                    />

                    <v-col cols="8">
                      <validation-provider
                        v-slot="{ errors }"
                        name="anmeldename"
                        rules="required"
                      >
                        <v-text-field
                          v-model="anmeldename"
                          :error-messages="errors"
                          color="secondary"
                          label="Anmeldename*"
                          type="text"
                          prepend-icon="mdi-face"
                          class="mt-10"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row
                    align="center"
                    dense
                  >
                    <v-col
                      class="text-right body-1 grey--text"
                      cols="2"
                    />

                    <v-col cols="8">
                      <validation-provider
                        v-slot="{ errors }"
                        name="password"
                        rules="required"
                      >
                        <v-text-field
                          v-model="password"
                          label="Password*"
                          :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show3 ? 'text' : 'password'"
                          color="secondary"
                          :error-messages="errors"
                          prepend-icon="mdi-lock-outline"
                          @click:append.prevent="show3 = !show3"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-card-actions class="pa-0">
                    <v-spacer />
                    <v-btn
                      type="submit"
                      form="loginForm"
                      large
                      color="success"
                      raised
                    >
                      Anmeldung
                    </v-btn>
                  </v-card-actions>
                </base-material-card>
              </form>
            </validation-observer>
          </v-col>
        </v-slide-y-transition>
      </v-row>
      <dashboard-core-footer />
    </v-container>
  </v-content>
</template>

<script>
  import * as types from '../../store/types'

  export default {
    name: 'DashboardLogin',

    $_veeValidate: {
      validator: 'new',
    },

    data () {
      return {
        anmeldename: '',
        password: '',
        show: false,
        show2: false,
        show3: false,
      }
    },

    methods: {
      validateForm (scope) {
        const formData = {
          userName: this.anmeldename,
          password: this.password,
        }
        try {
          this.$store.dispatch(types.ACTION_AUTH_LOGIN, {
            userName: formData.userName,
            password: formData.password,
          })
        } catch (error) {
          console.log('Error: ' + error + ' ' + types.ACTION_AUTH_LOGIN)
        }
      },
    },
  }
</script>
